import { render, staticRenderFns } from "./ReportGlobalvalueDailyLife.vue?vue&type=template&id=2873f0bf&scoped=true&"
import script from "./ReportGlobalvalueDailyLife.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueDailyLife.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueDailyLife.vue?vue&type=style&index=0&id=2873f0bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2873f0bf",
  null
  
)

export default component.exports